export default {
	getById(id, cb, ecb, config) {
		this.http
			.get(`/poll/getById/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/poll/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/poll/search/', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getItemById(id, cb, ecb, config) {
		this.http
			.get(`/poll/getItemById/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	tags(pid, cb) {
		//获取投票下全部投票项的标签并集
		this.http.get('/poll/tags/' + pid).then((r) => cb && cb(r))
	},
	updateItem(form, cb, ecb) {
		this.http
			.post('/poll/updateItem', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchItem(params, cb, ecb) {
		this.http
			.get('/poll/searchItem/', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	voteItems(form, cb, ecb) {
		this.http
			.post('/poll/voteItems', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getStats(id, cb, ecb) {
		this.http
			.get(`/poll/getStats/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
